/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Privacy_P1Inputs */

const en_pc_online_privacy_p1 = /** @type {(inputs: Pc_Online_Privacy_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online is a WebAssembly app with no server-side code. When you open a PDF, your browser reads it from your disk into the tab's memory; it is not uploaded to PDFCraftTool.org or anyone else. When you save, the edited file goes straight to your Downloads folder.`)
};

const zh_pc_online_privacy_p1 = /** @type {(inputs: Pc_Online_Privacy_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版是一个没有服务器端代码的 WebAssembly 应用。打开 PDF 时，浏览器把文件从你的磁盘读入标签页的内存，不会上传到 PDFCraftTool.org 或任何其他地方。保存时，编辑后的文件直接进入你的「下载」文件夹。`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online is a WebAssembly app with no server-side code. When you open a PDF, your browser reads it from your disk into the tab's memory; it is not upl..." |
*
* @param {Pc_Online_Privacy_P1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_privacy_p1 = /** @type {((inputs?: Pc_Online_Privacy_P1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Privacy_P1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_privacy_p1(inputs)
	return zh_pc_online_privacy_p1(inputs)
});
export { pc_online_privacy_p1 as "pc.online.privacy_p1" }